var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMultistep)?_c('time-on-step-chart'):_c('time-on-guide-chart')
}
var staticRenderFns = []

export { render, staticRenderFns }